import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
/**
 * O código em caixas, uma por dígito. Por baixo é um input só, transparente por
 * cima das caixas: colar o código, o preenchimento automático do celular
 * (`one-time-code`) e o backspace funcionam como num campo comum.
 */
export default class CodeInput extends Component {
  focused = false;
  view() {
    const {
      code,
      length,
      label,
      disabled
    } = this.attrs;
    const value = code();
    const active = this.focused ? Math.min(value.length, length - 1) : -1;
    return m("div", {
      className: classList('MagicLink-otp', {
        disabled
      })
    }, m("input", {
      id: "magicLinkCode",
      className: "MagicLink-otpInput",
      name: "code",
      type: "text",
      inputmode: "numeric",
      autocomplete: "one-time-code",
      pattern: "[0-9]*",
      maxlength: length,
      "aria-label": label,
      value: value,
      disabled: disabled,
      oninput: e => {
        const target = e.target;
        const digits = target.value.replace(/\D/g, '').slice(0, length);
        target.value = digits;
        code(digits);
      },
      onfocus: () => this.focused = true,
      onblur: () => this.focused = false
      // As caixas não têm cursor: ele fica sempre no fim do que já foi digitado.
      ,
      onkeyup: e => this.caretToEnd(e.target),
      onclick: e => this.caretToEnd(e.target)
    }), m("div", {
      className: "MagicLink-otpBoxes",
      "aria-hidden": "true"
    }, Array.from({
      length
    }, (_, i) => m("span", {
      className: classList('MagicLink-otpBox', {
        'is-filled': i < value.length,
        'is-active': i === active
      })
    }, value[i] || '-'))));
  }
  caretToEnd(input) {
    const end = input.value.length;
    if (input.selectionStart !== end) input.setSelectionRange(end, end);
  }
  onupdate(vnode) {
    super.onupdate(vnode);

    // O valor pode mudar por fora (novo código pedido, campo limpo).
    const input = this.element.querySelector('input');
    if (input && input.value !== this.attrs.code()) input.value = this.attrs.code();
  }
}
flarum.reg.add('ramon-magic-link', 'forum/components/CodeInput', CodeInput);